/* eslint-disable import/no-cycle */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import reduxThunk from 'redux-thunk';

import book from './book';
import vehicles from './vehicles';
import dealers from './dealers';
import creditCalc from './creditCalc';
import car from './car';
import { callbacksMiddleware } from '../middleware';

const reducer = combineReducers({
  book: book.reducer,
  vehicles: vehicles.reducer,
  dealers: dealers.reducer,
  creditCalc: creditCalc.reducer,
  car: car.reducer,
});

const middleware = [reduxThunk, callbacksMiddleware];
const store = configureStore({ reducer, middleware });

type State = ReturnType<typeof store.getState>;
type Store = typeof store;
type GetState = typeof store.getState;

export { store as default, State, Store, GetState };
